import Card from 'antd/lib/card'
import classes from './UserProfile.module.less'
import badgeIcon from '../../../assets/icons/header-badge.svg'
import LogoutIcon from '../../../assets/icons/logout.svg'
import Popover from 'antd/lib/popover'
import DownArrow from '../../../assets/icons/chevron-down.svg?react'
import { logoutUser } from 'src/utils/auth.utils'
import Icon from '@ant-design/icons/lib/components/Icon'
import { DataTestId, TextConstants } from 'src/constants/ui.constants'

const { PrivacyPolicy, Logout } = TextConstants.UserProfile

export type UserProfileType = {
    userName: string
    userEmail: string
    alignText: 'start' | 'end'
}

export const UserProfile: React.FC<UserProfileType> = (props: UserProfileType) => {
    return (
        <div className={classes.root} data-testid={DataTestId.UserProfile}>
            <div className={classes.userName} style={{ textAlign: props.alignText }}>
                {props.userName}
            </div>
            <div>
                <Popover
                    rootClassName={classes.popover}
                    content={
                        <Card classNames={{ body: classes.cardBody }}>
                            <div className={classes.cardContent}>
                                <div className={classes.cardContent1}>{props.userName}</div>
                                <div className={classes.cardContent2}>{props.userEmail}</div>
                                <div className={classes.settings}>
                                    <div className={classes.settingsText}>
                                        <img src={badgeIcon} />
                                        <span
                                            onClick={() =>
                                                window.open(
                                                    'https://www.telusinternational.com/privacy-policy/contributors?INTCMP=ti_privacypolicy_lin[…]data-annotation-solutions-community-data-privacy-notice',
                                                    '_blank',
                                                    'noopener noreferrer'
                                                )
                                            }
                                        >
                                            {PrivacyPolicy}
                                        </span>
                                    </div>
                                    <div className={classes.settingsText}>
                                        <img src={LogoutIcon} />
                                        <span onClick={() => logoutUser(window.location.href)}>
                                            {Logout}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    }
                    trigger="click"
                    placement={'bottomLeft'}
                >
                    <Icon component={DownArrow} className={classes.downArrow} />
                </Popover>
            </div>
        </div>
    )
}
